import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./_store";
import AppRouter from "./routes";
import { Toaster } from "react-hot-toast";
import "./UserCSS/Style.css";
import "./Global.css";
import "./UserCSS/Responsive.css";
import "./adminResponsive.css";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppRouter />
        <Toaster 
        toastOptions={{
          duration: 3000,
        }}
        />
      </PersistGate>
    </Provider>
  );
}
export default App;
